export default "__VITE_ASSET__BErVvjmV__"